import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { firestoreAppointmentActivityDataObject } from '../Bridge';
import { track } from '../tracking';
import { firestore } from '../firestore';

export const makeFirestoreTTL_For6months = () => {
    const sixMonthsFromNow = new Date();
    sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);
    return Timestamp.fromDate(sixMonthsFromNow);
};

export async function recordAppointmentActivityInFS(
    dataObject: firestoreAppointmentActivityDataObject,
    aid: string,
) {
    try {
        if (!aid) return;
        if (!dataObject || !Object.keys(dataObject).length) {
            track('appointent_activity_log_to_FS_v2_inCompleteData', {
                AppointmentActivitydataSentToWriteToFS: JSON.stringify(dataObject),
                errorMessage: 'the appointment activity object was empty',
            });
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        await addDoc(collection(firestore, 'appointments', aid, 'events'), dataObject);
    } catch (err) {
        track('appointent_activity_log_to_FS_v2_catchBlock', {
            AppointmentActivitydataSentToWriteToFS: JSON.stringify(dataObject),
            errorMessage: String(err),
        });
    }
}
